import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MovimentiService} from '../../../_services/movimenti.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {Contenitore} from '../../../_models/Contenitore';
import {SaveMessage} from '../../../_helpers/save-message';
import {LicenzeService} from "../../../_services/licenze.service";
import {constants} from "../../../_helpers/constants";
import {ModalController} from "@ionic/angular";
import {MovimentiRettificaComponent} from "../../movimenti/movimenti-rettifica/movimenti-rettifica.component";

@Component({
  selector: 'app-articolo-giacenza-lotto',
  templateUrl: './articolo-giacenza-lotto.component.html',
  styleUrls: ['./articolo-giacenza-lotto.component.scss'],
  standalone: false
})
export class ArticoloGiacenzaLottoComponent {
  @Input() activeSelect = false;
  @Input() giacenza: any;
  @Output() contenitoreSelect = new EventEmitter<Contenitore>();
  @Input() activeEdit = false;
  contenitori: Contenitore[] = [];
  showContenitori = false;
  countSelected = 0;
  loading = false;
  protected readonly constants = constants;

  constructor(
    public licenseService: LicenzeService,
    private saveMessage: SaveMessage,
    private organizzazioneService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private modalCtrl: ModalController) { }


  getContenitoriOfLotto() {
    this.showContenitori = !this.showContenitori;
    if (!this.showContenitori) {
      this.contenitori = [];
      return false;
    }
    this.loading = true;
    this.movimentiService
      .getContenitoriFilteredAsync(this.organizzazioneService.organizzazioneId, '', 0, 0,
        'codice', true, -1, this.giacenza.codArt, '', this.giacenza.codMag,
        this.giacenza.codAreaMag, this.giacenza.codLottoAlfa, true)
      .then((_contenitori: SearchResult<Contenitore>) => {
        this.contenitori = _contenitori.result ?? [];
        this.contenitori = this.contenitori.filter(c => c.giacenza > 0);
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei contenitori."))
      .finally(() => this.loading = false);
  }

  onSelectContenitore = (contenitore: Contenitore) => {
    if (this.activeEdit) {
      this.openRettificaBox(contenitore);
      return false;
    }
    if (this.activeSelect) {
      contenitore.isSelected = !contenitore.isSelected;
    }
    this.countSelected = this.contenitori
      .filter(p => p.isSelected).length;
    //.reduce((acc, p) => acc + p.giacenza, 0);

    this.contenitoreSelect.emit(contenitore);
  };

  async openRettifica(giacenza: any) {
    const modal = await this.modalCtrl.create({
      component: MovimentiRettificaComponent,
      componentProps: {
        codArt: giacenza.codArt, varianteArt: giacenza.varianteArt,
        codLottoAlfa: giacenza.codLottoAlfa, udM1: giacenza.magUm, udM2: giacenza.magUm2,
        qtaUdM1: giacenza.giacenza, qtaUdM2: giacenza.giacenzaUdM2,
        codMagIn: giacenza.codMag, codAreaIn: giacenza.codAreaMag
      },
      backdropDismiss: false,
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {role} = await modal.onWillDismiss();
    if (role === 'confirm') {
    }
  }

  async openRettificaBox(contenitore: Contenitore) {
    const modal = await this.modalCtrl.create({
      component: MovimentiRettificaComponent,
      componentProps: {
        codArt: contenitore.codArt, varianteArt: contenitore.varianteArt,
        codLottoAlfa: contenitore.codLottoAlfa, udM1: contenitore.udM, udM2: contenitore.udM2,
        qtaUdM1: contenitore.giacenza, qtaUdM2: contenitore.giacenzaUdM2, codBox: contenitore.codice,
        codMagIn: contenitore.codMagazzino, codAreaIn: contenitore.codMagArea
      },
      backdropDismiss: false,
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {role} = await modal.onWillDismiss();
    if (role === 'confirm') {
    }
  }
}
